/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, isEmpty } from "lodash";
import {
  IconButton,
  Pagination,
  Stack,
  Chip,
  Menu,
  MenuItem,
  Link as LinkMui,
  Button
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PhoneIcon from '@mui/icons-material/Phone';
import { useParams } from 'react-router-dom';
import ReplayIcon from '@mui/icons-material/Replay';

import Table from "../../../../components/form/Table";
import Notification from "../../../../components/form/Notification";
import Alert from "../../../../components/form/Alert";
import Question from "../../../../components/form/Question";
import DriverModal from "./DriverModal";
import AddIcon from '@mui/icons-material/Add';
import { useCanView } from "../../../../config/hook/UserPermissions";

import { getProviderId } from "../../../../store/masters/thunk/provider/getId";
import { deleteDriver } from "../../../../store/masters/thunk/driver/delete";

const Driver = ({ setBtns }) => {
  const [__] = useTranslation("supplierDrivers");
  const dispatch = useDispatch();
  const { id } = useParams();
  const PageSize = 5;
  const canView = useCanView();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
  const [openModal, setOpenModal] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(null);

  const driver = useSelector(state => state.masters.driver);
  
  const current = useSelector((state) => state.masters.provider.detail);
  const delet = useSelector(state => state.masters.driver.delete);
  const put = useSelector(state => state.masters.driver.put);
  const post = useSelector(state => state.masters.driver.post);

  const getData = ({ page, filter }) => {
    dispatch(getProviderId({ id }));
  };

  const reload = () => getData({ page: 1 })

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1 })
  }, [dispatch])

  useEffect(() => {
    setBtns(
      <Stack className='mr-4' direction="row" spacing={1} justifyContent="flex-end">
        <Button className='w-[100px] min-w-[100px]' startIcon={<AddIcon/>} variant="contained" color="secondary" onClick={() => {
            if (canView("MAESTROS/PROVEEDORES/CONDUCTORES", "add")) {
              setOpenModal(true)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para agregar nuevos conductores al proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`toolbar.btn`)}</Button>
        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
      </Stack>
    )
  }, [])

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };

  const handleEditService = (row) => {
    setSelected(row);  
    setOpenModal(true);  
  };

  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const onDelete = () => {
    dispatch(deleteDriver({ id: Number(get(selected, "idDriver")), idProvider: Number(get(selected, "idProvider")) }))
    setSelected({})
  }
  const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(true)
    setSelected(row)
  }

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (driver) => <li>{`• ${driver}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" })}
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" })}
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [post, put, delet])

  const driverAll = get(current, "data.drivers", []);

  const headTable = [
    {
      key: "status",
      label: __(`table.cols.isActive`),
      align: "center"
    },
    {
      key: "thisId",
      label: __(`table.cols.idDriver`),
      align: "center"
    },
    {
      key: "license",
      label: __(`table.cols.license`),
      align: "center"
    },
    {
      key: "name",
      label: __(`table.cols.name`),
      align: "center"
    },
    {
        key: "phone",
        label: __(`table.cols.phone`),
        align: "center"
    },
    {
    key: "email",
    label: __(`table.cols.email`),
    align: "center"
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]

  const dataTable = map(driverAll, (row, i) => ({
    ...row,
    status: <Chip label={get(row, "isActive") === true ? __("Activo") : __("Inactivo")} color={get(row, "isActive") === true ? "success" : "error"}/>,
    thisId: (<Button onClick={() => handleEditService(row)}>{get(row, "idDriver")}</Button>),
    phone: get(row, "phone", "") && <Stack direction="row" alignItems="center" spacing={1}><PhoneIcon fontSize="small" /><div>{get(row, "phone")}</div></Stack>,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))
  const onChangePagination = (e, page) => getData({ page })

  return (
    <div className='mt-4'>
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(current, "isLoading", false)}
      />
      {get(driver, "isSuccess", true) &&
        <Stack sx={{ mt: 2 }} alignContacts="flex-end">
          <Pagination
            count={(Math.trunc((get(driver, "totalRecords", 1) + PageSize) / PageSize))}
            page={get(driver, "pageNumber", 1)}
            onChange={onChangePagination}
            color="secondary"
            sx={{ "& li > button": { borderRadius: 1 } }}
          />
        </Stack>
      }
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <MenuItem onClick={() => { setOpenModal(true); setAnchorEl(null) }}>{__(`table.menu.edit`)}</MenuItem>
        <MenuItem onClick={ () => {
            if (canView("MAESTROS/PROVEEDORES/CONDUCTORES", "delete")) {
              handleDelete(selected)()
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para eliminar conductores del proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`table.menu.delete`)}</MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <DriverModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
        showNoti={showNoti}
        setShowNoti={setShowNoti}
        alert={alert}
        setAlert={setAlert}
        setError={setError}
        reload={reload}
        selected={selected}
        setSelected={setSelected}
        idClient={id}
      />
      <Question
        title={__("alert.deleteDriverProvider.title")}
        detail={__("alert.deleteDriverProvider.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </div>
  )
}

export default Driver;
